import { render, staticRenderFns } from "./BCheckboxGroupWithValidation.vue?vue&type=template&id=d456c5ea&scoped=true&"
import script from "./BCheckboxGroupWithValidation.vue?vue&type=script&lang=js&"
export * from "./BCheckboxGroupWithValidation.vue?vue&type=script&lang=js&"
import style0 from "./BCheckboxGroupWithValidation.vue?vue&type=style&index=0&id=d456c5ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d456c5ea",
  null
  
)

export default component.exports